import i18n from "@/lang";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import relativeTime from "dayjs/plugin/relativeTime";
import { useI18n } from "vue-i18n";
import copy from "copy-to-clipboard";
import { copyImageToClipboard } from "copy-image-clipboard";
import { ElMessage } from "element-plus";
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(relativeTime);
export const t = (key) => {
  const welcomeMessage = i18n.global.t(key);
  return welcomeMessage;
};
// 判断是否是一个图片
export function isImageUrl(url) {
  return /\.(jpg|jpeg|png|gif|bmp|svg)$/i.test(url);
}
export const formatTime = (inputTime) => {
  const { t } = useI18n();
  const now = dayjs();
  const time = dayjs(inputTime);
  const diffDays = now.diff(time, "day"); // 计算与当前时间相差的天数

  if (time.isToday()) {
    // 当天时间，返回时分
    return time.format("HH:mm");
  } else if (time.isYesterday()) {
    // 昨天，返回 "昨天 HH:mm"
    return `${t("conversation.time.yesterday")} ${time.format("HH:mm")}`;
  } else if (diffDays <= 3) {
    // 三天内（不包括昨天），返回星期几
    const weekdays = [
      t("conversation.time.sunday"),
      t("conversation.time.monday"),
      t("conversation.time.tuesday"),
      t("conversation.time.wednesday"),
      t("conversation.time.thursday"),
      t("conversation.time.friday"),
      t("conversation.time.saturday"),
    ];
    return `${weekdays[time.day()]}`;
  } else {
    // 手动处理日期格式
    const month = time.format("M"); // 获取月份
    const day = time.format("D"); // 获取日期
    return `${t("conversation.time.date_format", { month, day })}`;
  }
};
// 下载
export const downloadFile = (url, fileName) => {
  const a = document.createElement("a");
  a.style.display = "none";
  document.body.appendChild(a);
  a.href = url;
  a.download = fileName;
  a.click();
  document.body.removeChild(a);
};
// 复制文本
export const copyText = (val) => {
  let res = copy(val, { format: "text/plain" });
  if (res) {
    // 复制成功
    ElMessage.success(t("common.copySuccess"));
  }
};
// 复制图片
export async function copyImage(url) {
  const Blob = await copyImageToClipboard(url);
  if (Blob) {
    ElMessage.success(t("common.copySuccess"));
  }
}

// 清空数据
export const clearDataByType = (target, arr) => {
  arr.forEach((i) => {
    switch (Object.prototype.toString.call(target[i]).slice(8, -1)) {
      case "String":
        target[i] = "";
        break;
      case "Array":
        target[i] = [];
        break;
      case "Object":
        target[i] = {};
        break;
      default:
        target[i] = null;
        break;
    }
  });
};

export const formatDate = (date, forma) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0"); // 月份从0开始
  const day = String(d.getDate()).padStart(2, "0");
  const hour = String(d.getHours()).padStart(2, "0");
  const minute = String(d.getMinutes()).padStart(2, "0");
  const second = String(d.getSeconds()).padStart(2, "0");
  // 根据不同的格式化规则，组装日期字符串
  switch (forma) {
    case "YYYY-MM-DD HH:mm:ss":
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    case "YYYY-MM-DD":
      return `${year}-${month}-${day}`;
    case "YYYY-MM":
      return `${year}-${month}`;
    case "YYYY/MM/DD HH:mm:ss":
      return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
    case "YYYY/MM/DD":
      return `${year}/${month}/${day}`;
    case "YYYY/MM":
      return `${year}/${month}`;
    case "YYYYMMDDHHmmss":
      return `${year}${month}${day}${hour}${minute}${second}`;
    case "YYYYMMDD":
      return `${year}${month}${day}`;
    case "YYYYMM":
      return `${year}${month}`;
    default:
      return date;
  }
};
